// extracted by mini-css-extract-plugin
export default {"upload":"upload__Upload__p6rvd","label":"label__Upload__p6rvd","uploadIcon":"uploadIcon__Upload__p6rvd","disabled":"disabled__Upload__p6rvd","labelText":"labelText__Upload__p6rvd"};